import {registerReactPartial} from '@github-ui/react-core/register-partial'

import {GlobalCreateMenu} from './GlobalCreateMenu'

registerReactPartial('global-create-menu', {
  Component: GlobalCreateMenu,
})
